import React from 'react';
import { Link } from 'react-router-dom';
import styles from './BindingPage.module.scss';
import toyotaLogo from '../../assets/TOYOTA LOGO - Horizontal.svg';
import carBindingSvg from '../../assets/car-binding.svg';
import axios from 'axios';
import { encodeBase64Object } from 'shared/common';

export default function BindingCar() {
  const handleRedirect = async () => {
    const staticUrl = process.env.REACT_APP_TOYOTA_BIND_CAR_URL || "https://hotaimotor.page.link/MyToyota";

    const queryParams = new URLSearchParams(window.location.search);
    const token = queryParams.get('token');

    try {
      // const queryParams = new URLSearchParams(encodeBase64Object({
      //   auth_token: token
      // }));
      // const response = await axios.get(`${process.env.REACT_APP_BASE_URL}/bind_car_url?${queryParams.toString()}`);
      // console.log(response);

      // const redirectUrl = response.data?.data?.url || staticUrl;
      window.location.href = staticUrl;
    } catch (error) {
      console.error('Failed to parse JWT token:', error);
      window.location.href = staticUrl;
    }
  };

  return (
    <div className="center-viewport">
      <div className="toyota-header">
        <Link to="/">
          <img className="toyota-logo" src={toyotaLogo} alt="TOYOTA LOGO" style={{ height: '20px', width: 'auto', display: 'block', margin: '0 auto', cursor: 'pointer' }} />
        </Link>
      </div>
      <div className={styles['center-card']}>
        <img src={carBindingSvg} alt="綁定車輛" className={styles['status-icon']} />
        <div className={styles['status-title']}>綁定車輛</div>
        <div className={styles['status-desc']}>您已成功綁定和泰會員，接下來將為您進行車輛綁定，完成綁定後就可以使用TOYOTA車主專屬服務。</div>
        <button className={styles['status-btn']} onClick={handleRedirect}>好的</button>
      </div>
    </div>
  );
} 